<template>
  <div id="page">
    <div class="container margin_30">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="box_account">
            <div class="form_container">
              <div class="private box text-center">
                <h2>{{ $t('lang.forms.processing_social_auth') }}</h2>

                <h3 class="pl-0">
                  {{ $t('lang.forms.wait') }}
                </h3>

                <img
                  src="../assets/img/illustrations/MobileLogin.gif"
                  style="width: 80%; margin-bottom: 1.5rem"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import setAuthenticatedUserData from '../components/Auth/Authentication';

export default {
  name: 'StoreAppAuthData',

  // Called from ProcessSocialAuth.vue
  created() {
    const { query } = this.$route;

    setAuthenticatedUserData(query, this.$store, this.$gtag, this.$currencyByCountry);
  },
};
</script>

<style scoped>

</style>
